import NoticeBar from 'antd-mobile/lib/notice-bar';
export default NoticeBar;



// WEBPACK FOOTER //
// ./components/notice-bar/index.tsx